lmApp.controller('FavoritesController', ['$routeParams', '$location', '$q', '$scope', '$rootScope', '$filter', 'ToastService', 'SubscriberResource', 'FavouritesResource', 'AssetResource', 'ModalWindowService',
    function ($routeParams, $location, $q, $scope, $rootScope, $filter, ToastService, SubscriberResource, FavouritesResource, AssetResource, ModalWindowService) {
        $scope.loading = false;

        $scope.favourites = [];
        $scope.offset = 0;
        $scope.limit = 20;
        $scope.searchField = '';
        var collection = [];

        $scope.topFavourites = [];
        $scope.resultCount = -1;
        $scope.topOffset = 0;
        $scope.topLimit = 16;
        $scope.topType = '';
        var topCollection = [];

        var subscriberMap = {};
        var assetMap = {};

        var getSubscribers = function (ids) {
            var total = ids.length;
            var start = 0;
            var limit = 1000;
            var end = limit;
            var deferred = $q.defer();
            if (total === 0) {
                deferred.resolve();
                return deferred.promise;
            }

            var reqList = [];
            while (start < total) {
                var idPart = ids.slice(start, end);
                if (idPart.length === 0) break;
                reqList.push(SubscriberResource.get({'id[in]': idPart.join(',')}).$promise);
                start += end;
                end += limit;
            }

            $q.all(reqList)
                .then(function (values) {
                    for (var i = 0; i < values.length; i++) {
                        var subscribers = (values[i].data || []);
                        subscribers.forEach(function (user) {
                            subscriberMap[user.id] = user;
                        })
                    }
                    deferred.resolve();
                })
                .catch(function (reason) {
                    deferred.resolve();
                    $rootScope.debugInfo(reason, 'silent');
                });
            return deferred.promise;
        };

        var getAssets = function (ids) {
            var total = ids.length;
            var start = 0;
            var limit = 1000;
            var end = limit;
            var deferred = $q.defer();
            if (total === 0) {
                deferred.resolve();
                return deferred.promise;
            }

            var reqList = [];
            while (start < total) {
                var idPart = ids.slice(start, end);
                reqList.push(AssetResource.get({
                    'id[in]': idPart.join(','),
                    '$expand': 'categories'
                }).$promise);
                start += end;
                end += limit;
            }

            $q.all(reqList)
                .then(function (values) {
                    for (var i = 0; i < values.length; i++) {
                        var assets = values[i];
                        assets.forEach(function (asset) {
                            assetMap[asset.id] = asset;
                        })
                    }
                    deferred.resolve();
                })
                .catch(function (reason) {
                    deferred.resolve();
                    $rootScope.debugInfo(reason, 'silent');
                });
            return deferred.promise;
        };

        $scope.getFavourites = function () {
            if ($scope.loading) return;
            $scope.loading = true;
            $rootScope.showLinearProgress('#favouriteLoader');

            FavouritesResource.get().$promise
                .then(function (result) {
                        var records = (result.collection || []);
                        var subscriberIds = [];
                        var assetIds = [];
                        var assetCount = {};
                        records.forEach(function (record) {
                            if (!subscriberMap.hasOwnProperty(record.subscriber_id)) {
                                subscriberMap[record.subscriber_id] = {};
                                subscriberIds.push(record.subscriber_id);
                            }
                            if (!assetMap.hasOwnProperty(record.asset_id)) {
                                assetMap[record.asset_id] = {};
                                assetIds.push(record.asset_id);
                            }
                            if (!assetCount.hasOwnProperty(record.asset_id)) {
                                assetCount[record.asset_id] = {count: 0};
                            }
                            assetCount[record.asset_id].count++;
                        });

                        getSubscribers(subscriberIds)
                            .then(function () {
                                getAssets(assetIds)
                                    .then(function () {
                                        var result = [];
                                        for (var i = records.length - 1; i >= 0; i--) {
                                            var record = records[i];
                                            if (subscriberMap.hasOwnProperty(record.subscriber_id)
                                                && subscriberMap[record.subscriber_id].username
                                                && assetMap.hasOwnProperty(record.asset_id)
                                                && assetMap[record.asset_id].name) {
                                                result.push({
                                                    username: subscriberMap[record.subscriber_id].username,
                                                    assetId: assetMap[record.asset_id].id,
                                                    assetName: assetMap[record.asset_id].name,
                                                    assetType: assetMap[record.asset_id].type,
                                                    status: assetMap[record.asset_id].status,
                                                    categories: assetMap[record.asset_id].categories
                                                })
                                            }
                                        }
                                        $scope.favourites = result;
                                        $scope.resultCount = result.length;
                                        collection = angular.copy($scope.favourites);

                                        var topResult = [];
                                        for (var assetId in assetCount) {
                                            if (assetMap.hasOwnProperty(assetId) && assetMap[assetId].name) {
                                                topResult.push({
                                                    count: assetCount[assetId].count,
                                                    assetName: assetMap[assetId].name,
                                                    assetType: assetMap[assetId].type
                                                })
                                            }
                                        }
                                        $scope.topFavourites = _.sortBy(topResult, 'count').reverse();
                                        topCollection = angular.copy($scope.topFavourites);

                                        $scope.loading = false;
                                        $rootScope.hideLinearProgress('#favouriteLoader');
                                    });
                            });
                    }
                )
                .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#favouriteLoader');
                    $rootScope.debugInfo(reason, 'silent');
                    ToastService.Small({
                        title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                        color: 'amber',
                        icon: 'server-off',
                        blocked: true
                    }, 1000 * 3);
                })
        };

        $scope.nextPage = function () {
            if ($scope.offset + $scope.limit < $scope.favourites.length) {
                $scope.offset = $scope.offset + $scope.limit;
            }
        };

        $scope.prevPage = function () {
            $scope.offset = Math.max($scope.offset - $scope.limit, 0);
        };

        $scope.nextTopPage = function () {
            if ($scope.topOffset + $scope.topLimit < $scope.topFavourites.length) {
                $scope.topOffset = $scope.topOffset + $scope.topLimit;
            }
        };

        $scope.prevTopPage = function () {
            $scope.topOffset = Math.max($scope.topOffset - $scope.topLimit, 0);
        };

        $scope.filterTop = function () {
            $scope.topOffset = 0;
            var showChannels = $scope.topType === 'channel';
            $scope.topFavourites = $filter('filter')(topCollection, function (topFavourite) {
                if (showChannels) {
                    return topFavourite.assetType === 'channel';
                }
                return topFavourite.assetType !== 'channel';
            }, true)
        };

        $scope.refreshPage = function () {
            if ($scope.loading) {
                return
            }
            $scope.offset = 0;
            $scope.topOffset = 0;
            $scope.topType = '';
            $scope.searchField = '';
            $scope.getFavourites();
        };

        $scope.getFavourites();

        $scope.setSearchField = function (text) {
            $scope.searchField = text;
        };

        var searchWatcher = $scope.$watch('searchField', function (newVal) {
            $scope.offset = 0;
            $scope.favourites = $filter('filter')(collection, newVal);
            if (!newVal) {
                $scope.favourites = collection;
            }
        });

        $scope.$on('$destroy', function () {
            if (searchWatcher) searchWatcher();
        });
    }])
;
